export default class ClubDiscount {
    static INDIVIDUAL_DISCOUNT = 'individual';

    static fromData(data)
    {
        let clubDiscount = new ClubDiscount();
        clubDiscount.id = data.id;
        clubDiscount.name = data.name;

        Object.seal(clubDiscount);
        return clubDiscount;
    }

}
